import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createSlots as _createSlots, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_2 = {
  class: "data-table-shell"
};
const _hoisted_3 = {
  class: "data-table min-w-[1100px]"
};
const _hoisted_4 = {
  key: 0,
  class: "data-table-row"
};
const _hoisted_5 = {
  key: 1,
  class: "data-table-row"
};
const _hoisted_6 = {
  class: "data-table-td min-w-[280px]"
};
const _hoisted_7 = {
  class: "flex items-start gap-3"
};
const _hoisted_8 = {
  class: "min-w-0"
};
const _hoisted_9 = {
  class: "truncate text-sm font-semibold text-slate-900"
};
const _hoisted_10 = {
  class: "mt-1 text-xs text-slate-500"
};
const _hoisted_11 = {
  class: "data-table-td text-sm text-slate-600"
};
const _hoisted_12 = {
  class: "data-table-td text-sm text-slate-600"
};
const _hoisted_13 = {
  class: "data-table-td text-sm text-slate-600"
};
const _hoisted_14 = {
  class: "data-table-td"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "data-table-td"
};
const _hoisted_17 = {
  class: "data-table-td text-sm text-slate-600"
};
const _hoisted_18 = {
  class: "data-table-td is-center whitespace-nowrap data-table-sticky-right data-table-sticky-action"
};
const _hoisted_19 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = ["onClick"];
const _hoisted_22 = ["onClick"];
const _hoisted_23 = ["onClick"];
const _hoisted_24 = {
  class: "flex items-start justify-between gap-4 border-b border-slate-200 bg-slate-50 px-5 py-4 md:px-6"
};
const _hoisted_25 = {
  class: "min-w-0"
};
const _hoisted_26 = {
  class: "mt-1 truncate text-sm text-slate-500"
};
const _hoisted_27 = {
  class: "border-b border-slate-100 px-5 py-4 md:px-6"
};
const _hoisted_28 = {
  class: "grid grid-cols-2 gap-3 md:grid-cols-5"
};
const _hoisted_29 = {
  class: "rounded-xl border border-slate-100 bg-slate-50 px-3 py-3"
};
const _hoisted_30 = {
  class: "mt-1 text-lg font-semibold text-slate-900"
};
const _hoisted_31 = {
  class: "rounded-xl border border-amber-100 bg-amber-50 px-3 py-3"
};
const _hoisted_32 = {
  class: "mt-1 text-lg font-semibold text-amber-700"
};
const _hoisted_33 = {
  class: "rounded-xl border border-slate-100 bg-slate-50 px-3 py-3"
};
const _hoisted_34 = {
  class: "mt-1 text-lg font-semibold text-slate-700"
};
const _hoisted_35 = {
  class: "rounded-xl border border-blue-100 bg-blue-50 px-3 py-3"
};
const _hoisted_36 = {
  class: "mt-1 text-lg font-semibold text-blue-700"
};
const _hoisted_37 = {
  class: "rounded-xl border border-violet-100 bg-violet-50 px-3 py-3"
};
const _hoisted_38 = {
  class: "mt-1 text-lg font-semibold text-violet-700"
};
const _hoisted_39 = {
  class: "rounded-xl border border-emerald-100 bg-emerald-50 px-3 py-3"
};
const _hoisted_40 = {
  class: "mt-1 text-lg font-semibold text-emerald-700"
};
const _hoisted_41 = {
  class: "flex-1 overflow-y-auto px-5 py-4 md:px-6"
};
const _hoisted_42 = {
  key: 0,
  class: "flex items-center justify-center py-12"
};
const _hoisted_43 = {
  key: 1,
  class: "overflow-hidden rounded-xl border border-slate-200"
};
const _hoisted_44 = {
  class: "min-w-full divide-y divide-slate-200"
};
const _hoisted_45 = {
  class: "divide-y divide-slate-100 bg-white"
};
const _hoisted_46 = {
  class: "px-4 py-3"
};
const _hoisted_47 = {
  class: "flex items-center gap-3"
};
const _hoisted_48 = {
  class: "flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-slate-100 text-sm font-semibold text-slate-600"
};
const _hoisted_49 = {
  class: "min-w-0"
};
const _hoisted_50 = {
  class: "truncate text-sm font-medium text-slate-900"
};
const _hoisted_51 = {
  class: "mt-0.5 text-xs text-slate-400"
};
const _hoisted_52 = {
  class: "px-4 py-3"
};
const _hoisted_53 = {
  class: "flex flex-col items-start gap-1"
};
const _hoisted_54 = {
  key: 0,
  class: "text-xs text-slate-500"
};
const _hoisted_55 = {
  class: "px-4 py-3 whitespace-nowrap text-sm text-slate-600"
};
const _hoisted_56 = {
  key: 2,
  class: "flex flex-col items-center justify-center rounded-xl border border-dashed border-slate-200 py-12"
};
import { computed, getCurrentInstance, onMounted, reactive, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import ReminderDefinitionFormModal from '@/views/reminder/components/ReminderDefinitionFormModal.vue';
import AppModal from '@/components/AppModal.vue';
import { createReminderDefinition, deleteReminderDefinition, disableReminderDefinition, enableReminderDefinition, getReminderDefinitionDetail, getReminderDefinitionPage, updateReminderDefinition } from '@/api/reminder';
export default {
  __name: 'ReminderDefinitionList',
  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const route = useRoute();
    const router = useRouter();
    const {
      proxy
    } = getCurrentInstance();
    const loading = ref(false);
    const submitting = ref(false);
    const list = ref([]);
    const editingDetail = ref(null);
    const modalVisible = ref(false);
    const modalMode = ref('create');
    const receiverDialogVisible = ref(false);
    const receiverDialogLoading = ref(false);
    const selectedReceiverDefinition = ref(null);
    const filters = reactive({
      keyword: '',
      status: ''
    });
    const pagination = ref({
      current: 1,
      size: 10,
      total: 0,
      pages: 0
    });
    const embedded = computed(() => props.embedded);
    const contentCardClass = computed(() => embedded.value ? 'list-page-table-panel' : 'list-page-table-panel list-page-table-panel--fill');
    const selectedReceivers = computed(() => selectedReceiverDefinition.value?.receivers || []);
    const receiverStatusStats = computed(() => {
      const receivers = selectedReceivers.value;
      return {
        total: receivers.length,
        pendingRemind: receivers.filter(item => resolveReceiverDisplayStatus(item) === 'PENDING_REMIND').length,
        unhandled: receivers.filter(item => resolveReceiverDisplayStatus(item) === 'UNHANDLED').length,
        converted: receivers.filter(item => resolveReceiverDisplayStatus(item) === 'CONVERTED_TO_TODO').length,
        postponed: receivers.filter(item => resolveReceiverDisplayStatus(item) === 'POSTPONED').length,
        handled: receivers.filter(item => resolveReceiverDisplayStatus(item) === 'HANDLED').length
      };
    });

    // const summary = computed(() => ({
    //   total: pagination.value.total || 0,
    //   enabled: list.value.filter(item => item.status === 'ENABLED').length,
    //   receivers: list.value.reduce((sum, item) => sum + Number(item.receiverCount || 0), 0)
    // }))

    watch(() => route.query.edit, async editId => {
      if (embedded.value) return;
      if (!editId) return;
      await openEditById(editId);
    }, {
      immediate: true
    });
    watch(modalVisible, visible => {
      if (embedded.value) return;
      if (!visible && route.query.edit) {
        const nextQuery = {
          ...route.query
        };
        delete nextQuery.edit;
        router.replace({
          query: nextQuery
        });
      }
    });
    function formatDateTime(value) {
      if (!value) return '';
      if (typeof proxy?.$formatDateTime === 'function') {
        return proxy.$formatDateTime(value);
      }
      return String(value).replace('T', ' ');
    }
    function statusText(status) {
      return status === 'ENABLED' ? '启用中' : '已停用';
    }
    function normalizeReceiverResponseStatus(status) {
      return String(status || 'UNHANDLED').toUpperCase();
    }
    function isBeforeFirstSendTime() {
      const firstSendTime = selectedReceiverDefinition.value?.firstSendTime;
      if (!firstSendTime) return false;
      const date = new Date(String(firstSendTime).replace(' ', 'T'));
      return !Number.isNaN(date.getTime()) && date.getTime() > Date.now();
    }
    function resolveReceiverDisplayStatus(receiver) {
      const normalized = normalizeReceiverResponseStatus(receiver?.responseStatus);
      if (normalized === 'UNHANDLED' && isBeforeFirstSendTime()) {
        return 'PENDING_REMIND';
      }
      return normalized;
    }
    function receiverResponseStatusText(receiver) {
      const normalized = resolveReceiverDisplayStatus(receiver);
      if (normalized === 'PENDING_REMIND') return '待提醒';
      if (normalized === 'HANDLED') return '已处理';
      if (normalized === 'CONVERTED_TO_TODO') return '已转待办';
      if (normalized === 'POSTPONED') return '已延期';
      if (normalized === 'TIMEOUT') return '已超时';
      return receiver?.responseStatusDesc || '未处理';
    }
    function receiverResponseStatusClass(receiver) {
      const normalized = resolveReceiverDisplayStatus(receiver);
      if (normalized === 'HANDLED') return 'is-success';
      if (normalized === 'CONVERTED_TO_TODO') return 'is-info';
      if (normalized === 'POSTPONED') return 'is-purple';
      if (normalized === 'TIMEOUT') return 'is-danger';
      if (normalized === 'PENDING_REMIND') return 'is-neutral';
      return 'is-warning';
    }
    function receiverPostponedTimeText(receiver) {
      if (resolveReceiverDisplayStatus(receiver) !== 'POSTPONED') {
        return '';
      }
      return formatDateTime(receiver?.postponedTime) || '';
    }
    function receiverAvatarText(receiver) {
      const name = receiver?.userName || String(receiver?.userId || '');
      return name ? name.slice(0, 1).toUpperCase() : '-';
    }
    function formatRepeat(item) {
      if (!item.repeatEnabled) return '单次提醒';
      return '重复提醒';
    }
    async function fetchList() {
      loading.value = true;
      try {
        const result = await getReminderDefinitionPage({
          pageNum: pagination.value.current,
          pageSize: pagination.value.size,
          keyword: filters.keyword || undefined,
          status: filters.status || undefined
        });
        list.value = result?.records || [];
        pagination.value = {
          current: result?.current || pagination.value.current,
          size: result?.size || pagination.value.size,
          total: result?.total || 0,
          pages: result?.pages || 0
        };
      } catch (error) {
        ElMessage.error('获取提醒定义失败');
        console.error('获取提醒定义失败', error);
      } finally {
        loading.value = false;
      }
    }
    function handleSearch() {
      pagination.value.current = 1;
      fetchList();
    }
    function handleReset() {
      filters.keyword = '';
      filters.status = '';
      pagination.value.current = 1;
      fetchList();
    }
    function handlePageChange(page) {
      pagination.value.current = page;
      fetchList();
    }
    function handlePageSizeChange(size) {
      pagination.value.size = size;
      pagination.value.current = 1;
      fetchList();
    }
    function openCreate() {
      modalMode.value = 'create';
      editingDetail.value = null;
      modalVisible.value = true;
    }
    async function handleEdit(id) {
      if (embedded.value) {
        await openEditById(id);
        return;
      }
      await router.replace({
        query: {
          ...route.query,
          edit: id
        }
      });
    }
    async function openEditById(id) {
      try {
        const detail = await getReminderDefinitionDetail(id);
        editingDetail.value = detail;
        modalMode.value = 'edit';
        modalVisible.value = true;
      } catch (error) {
        ElMessage.error('获取提醒详情失败');
        console.error('获取提醒详情失败', error);
      }
    }
    async function openReceiverStatusDialog(item) {
      selectedReceiverDefinition.value = {
        ...item,
        receivers: item?.receivers || []
      };
      receiverDialogVisible.value = true;
      if (selectedReceiverDefinition.value.receivers.length || !item?.id) {
        return;
      }
      receiverDialogLoading.value = true;
      try {
        const detail = await getReminderDefinitionDetail(item.id);
        selectedReceiverDefinition.value = {
          ...item,
          ...detail,
          receivers: detail?.receivers || []
        };
      } catch (error) {
        ElMessage.error('获取接收人状态失败');
        console.error('获取接收人状态失败', error);
      } finally {
        receiverDialogLoading.value = false;
      }
    }
    function closeReceiverStatusDialog() {
      receiverDialogVisible.value = false;
      receiverDialogLoading.value = false;
      selectedReceiverDefinition.value = null;
    }
    async function toggleStatus(item, enabled) {
      const actionText = enabled ? '启用' : '停用';
      try {
        await ElMessageBox.confirm(`确定要${actionText}提醒“${item.title}”吗？`, `${actionText}确认`, {
          confirmButtonText: actionText,
          cancelButtonText: '取消',
          type: enabled ? 'success' : 'warning'
        });
        if (enabled) {
          await enableReminderDefinition(item.id);
        } else {
          await disableReminderDefinition(item.id);
        }
        ElMessage.success(`${actionText}成功`);
        await fetchList();
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error(`${actionText}失败`);
          console.error(`${actionText}失败`, error);
        }
      }
    }
    async function handleDelete(item) {
      try {
        await ElMessageBox.confirm(`确定删除提醒“${item.title}”吗？删除后不可恢复。`, '删除确认', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await deleteReminderDefinition(item.id);
        ElMessage.success('删除成功');
        if (list.value.length === 1 && pagination.value.current > 1) {
          pagination.value.current -= 1;
        }
        await fetchList();
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('删除失败');
          console.error('删除失败', error);
        }
      }
    }
    async function submitForm(payload) {
      submitting.value = true;
      try {
        if (modalMode.value === 'edit' && editingDetail.value?.id) {
          await updateReminderDefinition(editingDetail.value.id, payload);
          ElMessage.success('提醒定义已更新');
        } else {
          await createReminderDefinition(payload);
          ElMessage.success('提醒定义已创建');
        }
        modalVisible.value = false;
        await fetchList();
      } catch (error) {
        ElMessage.error(error?.message || '保存提醒定义失败');
        console.error('保存提醒定义失败', error);
      } finally {
        submitting.value = false;
      }
    }
    onMounted(() => {
      fetchList();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: !embedded.value,
        bare: embedded.value
      }, _createSlots({
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass(contentCardClass.value)
        }, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: fetchList
        }, _createSlots({
          searchActionsLeading: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary inline-flex items-center gap-2",
            onClick: openCreate
          }, [...(_cache[6] || (_cache[6] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 新建提醒 ", -1)]))])]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: handleSearch
          }, "搜索"), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: handleReset
          }, "重置")]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filters.keyword = $event),
            type: "text",
            placeholder: "搜索标题或提醒内容",
            class: "form-search-input form-control-sm w-full",
            onKeyup: _withKeys(handleSearch, ["enter"])
          }, null, 544), [[_vModelText, filters.keyword]]), _cache[4] || (_cache[4] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _createVNode(_component_el_select, {
            modelValue: filters.status,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filters.status = $event),
            clearable: "",
            class: "form-select form-control-sm filter-bar-field",
            placeholder: "请选择状态"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "启用中",
              value: "ENABLED"
            }), _createVNode(_component_el_option, {
              label: "已停用",
              value: "DISABLED"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 2
        }, [!embedded.value ? {
          name: "actions",
          fn: _withCtx(() => [_createVNode(_component_router_link, {
            to: "/reminders/my-tasks",
            class: "btn-secondary inline-flex items-center gap-2"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createElementVNode("svg", {
              class: "h-4 w-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
            })], -1), _createTextVNode(" 我的任务 ", -1)]))]),
            _: 1
          })]),
          key: "0"
        } : undefined]), 1032, ["refresh-loading"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
          class: _normalizeClass(embedded.value ? 'data-table-scroll' : 'data-table-scroll data-table-scroll--fill')
        }, [_createElementVNode("table", _hoisted_3, [_cache[16] || (_cache[16] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "提醒标题"), _createElementVNode("th", {
          class: "data-table-th text-left w-40"
        }, "首次提醒"), _createElementVNode("th", {
          class: "data-table-th text-left w-24"
        }, "重复规则"), _createElementVNode("th", {
          class: "data-table-th text-left w-40"
        }, "截止时间"), _createElementVNode("th", {
          class: "data-table-th text-left w-20"
        }, "接收人数"), _createElementVNode("th", {
          class: "data-table-th text-left w-20"
        }, "状态"), _createElementVNode("th", {
          class: "data-table-th text-left w-40"
        }, "创建时间"), _createElementVNode("th", {
          class: "data-table-th is-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [...(_cache[7] || (_cache[7] = [_createElementVNode("td", {
          colspan: "8",
          class: "data-table-empty"
        }, [_createElementVNode("div", {
          class: "flex items-center justify-center gap-2 text-slate-500"
        }, [_createElementVNode("div", {
          class: "w-5 h-5 border-2 border-primary-600 border-t-transparent rounded-full animate-spin"
        }), _createTextVNode(" 加载中... ")])], -1)]))])) : !list.value.length ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [...(_cache[8] || (_cache[8] = [_createElementVNode("td", {
          colspan: "8",
          class: "data-table-empty"
        }, " 暂无提醒定义，点击“新建提醒”开始创建 ", -1)]))])) : (_openBlock(true), _createElementBlock(_Fragment, {
          key: 2
        }, _renderList(list.value, item => {
          return _openBlock(), _createElementBlock("tr", {
            key: item.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[9] || (_cache[9] = _createElementVNode("div", {
            class: "mt-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-blue-50 text-blue-600"
          }, [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V4a2 2 0 10-4 0v1.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
          })])], -1)), _createElementVNode("div", _hoisted_8, [_createElementVNode("p", _hoisted_9, _toDisplayString(item.title), 1), _createElementVNode("p", _hoisted_10, "定义 ID: " + _toDisplayString(item.id), 1)])])]), _createElementVNode("td", _hoisted_11, _toDisplayString(formatDateTime(item.firstSendTime) || '-'), 1), _createElementVNode("td", _hoisted_12, _toDisplayString(formatRepeat(item)), 1), _createElementVNode("td", _hoisted_13, _toDisplayString(formatDateTime(item.deadlineTime) || '未设置'), 1), _createElementVNode("td", _hoisted_14, [_createElementVNode("button", {
            type: "button",
            class: "status-badge bg-orange-100 text-orange-700 transition-colors hover:bg-orange-200",
            title: "查看接收人处理状态",
            onClick: $event => openReceiverStatusDialog(item)
          }, [_createElementVNode("span", null, _toDisplayString(item.receiverCount || 0) + " 人", 1), _cache[10] || (_cache[10] = _createElementVNode("svg", {
            class: "ml-1 h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 5l7 7-7 7"
          })], -1))], 8, _hoisted_15)]), _createElementVNode("td", _hoisted_16, [_createElementVNode("span", {
            class: _normalizeClass(["status-badge", item.status === 'ENABLED' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'])
          }, [_cache[11] || (_cache[11] = _createElementVNode("span", {
            class: "w-1.5 h-1.5 bg-current rounded-full mr-1"
          }, null, -1)), _createTextVNode(" " + _toDisplayString(item.statusDesc || statusText(item.status)), 1)], 2)]), _createElementVNode("td", _hoisted_17, _toDisplayString(formatDateTime(item.createTime) || '-'), 1), _createElementVNode("td", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("button", {
            class: "table-action-button is-primary",
            title: "编辑",
            "aria-label": "编辑",
            onClick: $event => handleEdit(item.id)
          }, [...(_cache[12] || (_cache[12] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5M18.586 2.586a2 2 0 112.828 2.828L12 14.828l-4 1 1-4 9.586-9.242z"
          })], -1)]))], 8, _hoisted_20), item.status === 'ENABLED' ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "table-action-button is-warning",
            title: "停用",
            "aria-label": "停用",
            onClick: $event => toggleStatus(item, false)
          }, [...(_cache[13] || (_cache[13] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
          })], -1)]))], 8, _hoisted_21)) : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "table-action-button is-success",
            title: "启用",
            "aria-label": "启用",
            onClick: $event => toggleStatus(item, true)
          }, [...(_cache[14] || (_cache[14] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M14.752 11.168l-3.197-2.132A1 1 0 0010 9.868v4.264a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 12A9 9 0 113 12a9 9 0 0118 0z"
          })], -1)]))], 8, _hoisted_22)), _createElementVNode("button", {
            class: "table-action-button is-danger",
            title: "删除",
            "aria-label": "删除",
            onClick: $event => handleDelete(item)
          }, [...(_cache[15] || (_cache[15] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_23)])])]);
        }), 128))])])], 2)]), pagination.value.total > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          current: pagination.value.current,
          size: pagination.value.size,
          total: pagination.value.total,
          pages: pagination.value.pages,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["current", "size", "total", "pages"])) : _createCommentVNode("", true)], 2), _createVNode(ReminderDefinitionFormModal, {
          visible: modalVisible.value,
          "onUpdate:visible": _cache[2] || (_cache[2] = $event => modalVisible.value = $event),
          mode: modalMode.value,
          detail: editingDetail.value,
          saving: submitting.value,
          onSubmit: submitForm
        }, null, 8, ["visible", "mode", "detail", "saving"]), _createVNode(AppModal, {
          visible: receiverDialogVisible.value,
          size: "3xl",
          "panel-class": "max-h-[min(760px,calc(100vh-2rem))] border border-slate-200",
          "z-index": 60,
          scrollable: false,
          onClose: closeReceiverStatusDialog
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_cache[17] || (_cache[17] = _createElementVNode("h2", {
            class: "truncate text-lg font-semibold text-slate-900"
          }, "接收人处理状态", -1)), _createElementVNode("p", _hoisted_26, _toDisplayString(selectedReceiverDefinition.value?.title || '未命名提醒'), 1)]), _createElementVNode("button", {
            type: "button",
            class: "inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-slate-200 text-slate-500 transition-colors hover:border-slate-300 hover:text-slate-900",
            title: "关闭",
            onClick: closeReceiverStatusDialog
          }, [...(_cache[18] || (_cache[18] = [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_cache[19] || (_cache[19] = _createElementVNode("p", {
            class: "text-xs text-slate-500"
          }, "接收人数", -1)), _createElementVNode("p", _hoisted_30, _toDisplayString(receiverStatusStats.value.total), 1)]), _createElementVNode("div", _hoisted_31, [_cache[20] || (_cache[20] = _createElementVNode("p", {
            class: "text-xs text-amber-600"
          }, "未处理", -1)), _createElementVNode("p", _hoisted_32, _toDisplayString(receiverStatusStats.value.unhandled), 1)]), _createElementVNode("div", _hoisted_33, [_cache[21] || (_cache[21] = _createElementVNode("p", {
            class: "text-xs text-slate-600"
          }, "待提醒", -1)), _createElementVNode("p", _hoisted_34, _toDisplayString(receiverStatusStats.value.pendingRemind), 1)]), _createElementVNode("div", _hoisted_35, [_cache[22] || (_cache[22] = _createElementVNode("p", {
            class: "text-xs text-blue-600"
          }, "已转待办", -1)), _createElementVNode("p", _hoisted_36, _toDisplayString(receiverStatusStats.value.converted), 1)]), _createElementVNode("div", _hoisted_37, [_cache[23] || (_cache[23] = _createElementVNode("p", {
            class: "text-xs text-violet-600"
          }, "已延期", -1)), _createElementVNode("p", _hoisted_38, _toDisplayString(receiverStatusStats.value.postponed), 1)]), _createElementVNode("div", _hoisted_39, [_cache[24] || (_cache[24] = _createElementVNode("p", {
            class: "text-xs text-emerald-600"
          }, "已处理", -1)), _createElementVNode("p", _hoisted_40, _toDisplayString(receiverStatusStats.value.handled), 1)])])]), _createElementVNode("div", _hoisted_41, [receiverDialogLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_42, [...(_cache[25] || (_cache[25] = [_createElementVNode("svg", {
            class: "h-7 w-7 animate-spin text-blue-500",
            fill: "none",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("circle", {
            class: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "4"
          }), _createElementVNode("path", {
            class: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          })], -1)]))])) : selectedReceivers.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_43, [_createElementVNode("table", _hoisted_44, [_cache[26] || (_cache[26] = _createElementVNode("thead", {
            class: "bg-slate-50"
          }, [_createElementVNode("tr", null, [_createElementVNode("th", {
            class: "px-4 py-3 text-left text-xs font-semibold text-slate-500"
          }, "接收人"), _createElementVNode("th", {
            class: "px-4 py-3 text-left text-xs font-semibold text-slate-500"
          }, "处理状态"), _createElementVNode("th", {
            class: "px-4 py-3 text-left text-xs font-semibold text-slate-500"
          }, "处理时间")])], -1)), _createElementVNode("tbody", _hoisted_45, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedReceivers.value, receiver => {
            return _openBlock(), _createElementBlock("tr", {
              key: receiver.userId,
              class: "hover:bg-slate-50/70"
            }, [_createElementVNode("td", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, _toDisplayString(receiverAvatarText(receiver)), 1), _createElementVNode("div", _hoisted_49, [_createElementVNode("p", _hoisted_50, _toDisplayString(receiver.userName || '未命名用户'), 1), _createElementVNode("p", _hoisted_51, "ID: " + _toDisplayString(receiver.userId || '-'), 1)])])]), _createElementVNode("td", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createElementVNode("span", {
              class: _normalizeClass(['status-badge', receiverResponseStatusClass(receiver)])
            }, _toDisplayString(receiverResponseStatusText(receiver)), 3), receiverPostponedTimeText(receiver) ? (_openBlock(), _createElementBlock("span", _hoisted_54, " 延期至 " + _toDisplayString(receiverPostponedTimeText(receiver)), 1)) : _createCommentVNode("", true)])]), _createElementVNode("td", _hoisted_55, _toDisplayString(formatDateTime(receiver.handledTime) || '-'), 1)]);
          }), 128))])])])) : (_openBlock(), _createElementBlock("div", _hoisted_56, [...(_cache[27] || (_cache[27] = [_createElementVNode("div", {
            class: "empty-state-icon"
          }, [_createElementVNode("svg", {
            class: "h-7 w-7",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.8",
            d: "M17 20h5v-2a4 4 0 00-4-4h-1M9 20H4v-2a4 4 0 014-4h1m4-4a4 4 0 100-8 4 4 0 000 8zm6 2a3 3 0 100-6"
          })])], -1), _createElementVNode("p", {
            class: "empty-state-title"
          }, "暂无接收人数据", -1)]))]))])]),
          _: 1
        }, 8, ["visible"])]),
        _: 2
      }, [!embedded.value ? {
        name: "header",
        fn: _withCtx(() => [_cache[3] || (_cache[3] = _createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "提醒定义"), _createElementVNode("p", {
          class: "list-page-description"
        }, "只展示由你创建的提醒定义。可复用现有账单/方案提醒能力，为多人配置自定义提醒、重复规则和跳转路径。")])])], -1))]),
        key: "0"
      } : undefined]), 1032, ["fill", "bare"]);
    };
  }
};